'use client';

import { ComponentProps, ReactNode, createContext } from 'react';
import { Layout } from '@/shared/ui/layout';
import { Modal } from '@/shared/ui/modal';
import { ModalProps } from '@/shared/ui/modal/types';
import { BlogDetailWrapper, BlogDetailTitle, BlogDetailMedia, BlogDetailContent } from '@/widgets/blog';
import './blog-detail-modal.scss';

type Props = ModalProps & {
    children?: ReactNode;
};

const BlogDetailModalContext = createContext<Record<string, never> | null>(null);

/** Provider that only provides context and renders children (Modal prefab). */
export const BlogDetailModalProvider = ({ children }: Props) => {
    return <BlogDetailModalContext.Provider value={{}}>{children}</BlogDetailModalContext.Provider>;
};

export const BlogDetailModalWrapper = ({ children, ...props }: Props) => {
    return (
        <BlogDetailModalContext.Provider value={{}}>
            <Modal
                {...props}
                wrapperProps={{
                    className: 'blog-detail-modal',
                    containerProps: {
                        className: 'blog-detail-modal__container',
                    },
                    'data-testid': 'blog-detail-modal',
                }}
            >
                {children}
            </Modal>
        </BlogDetailModalContext.Provider>
    );
};

type TitleProps = ComponentProps<typeof Layout>;
const BlogDetailModalTitle = ({ media, ...props }: TitleProps) => {
    return (
        <Layout element={Modal.Title} media={media} data-testid="blog-detail-modal-title" {...props}>
            {/* Title is usually handled by the content, but we keep this for structure if needed */}
        </Layout>
    );
};

/** Renders blog detail using BlogDetailWrapper (requires PageContext with POST_SLUG). */
const BlogDetailModalBlogDetail = (props: ComponentProps<typeof BlogDetailWrapper>) => {
    return (
        <BlogDetailWrapper {...props}>
            <BlogDetailTitle />
            <BlogDetailMedia />
            <BlogDetailContent />
        </BlogDetailWrapper>
    );
};

export { BlogDetailModalWrapper as BlogDetailModal };

export {
    BlogDetailModalWrapper as Wrapper,
    BlogDetailModalProvider as Provider,
    BlogDetailModalTitle as Title,
    BlogDetailModalBlogDetail as BlogDetailComponent,
};
